import { useI18n } from "i18n";
import { PAGES, usePageTracking } from "modules/tracking";
import ForgetPasswordView from "./ForgetPasswordView";
import AuthViewContainer from "../layout/AuthViewContainer";
import { AuthTopBlock } from "../layout/AuthTopBlock";
import AuthViewContent from "../layout/AuthViewContent";

const ForgetPasswordContainer = () => {
  const { t } = useI18n(["auth"]);

  usePageTracking(PAGES.FORGOT_PASSWORD);

  return (
    <AuthViewContainer>
      <AuthViewContent>
        <AuthTopBlock
          title={t("auth:recover.password")}
          text={t("auth:recover.password.text")}
        />
        <ForgetPasswordView />
      </AuthViewContent>
    </AuthViewContainer>
  );
};

export default ForgetPasswordContainer;
